<template>
  <div class="form-group" :class="{ 'has-error' : model.$error }" >
    <label v-if="showLabel" class="control-label col-sm-4">* Department:</label>
    <div :class="{ 'col-sm-8': showLabel }">
      <selectize
        class="form-control selectize selectize-single"
        :class="model.$error ? 'has-error red-border' : ''"
        name="department"
        v-model="model.$model"
        :options="departmentOptions"
        @input="() => { $emit('input', model.$model) }"
        :fetch-results="getDepartments"
        :fetch-more-results="getNextDepartments"/>

      <div v-if="model.$error" class="help-block pull-right">Department is required</div>
    </div>
  </div>
</template>

<script>
import Selectize from '../ext/codium/CodiumSelectize'
import { http } from 'utils'
import { concat } from 'lodash'

export default {
  props: {
    model: {
      required: true
    },
    default: {
      required: false,
      default: null
    },
    additionalDepartments: {
      required: false,
      default: null
    },
    showLabel: {
      required: false,
      default: true
    },
    restricted_departments_only: {
      required: false,
      default: false
    }
  },

  data () {
    return {
      departments: [],
      pagination: {}
    }
  },

  components: {
    Selectize
  },

  created () {
    this.getDepartments()
  },

  computed: {
    departmentOptions () {
      let departments = this.restricted_departments_only ? this.departments.filter(item => item.restricted) : this.departments
      departments = departments.map(item => {
        return {id: item.id, text: item.name}
      })
      if (this.default && departments.findIndex(element => element.id === this.default.id) === -1) {
        departments.push({ id: this.default.id, text: this.default.name })
        this.$emit('added', { id: this.default.id, text: this.default.name })
      }
      return departments
    }
  },

  methods: {
    getDepartments (search) {
      return http.get(`departments`, { params: { search } })
        .then((response) => {
          this.departments = response.data.data
          this.pagination = response.data.meta
        })
    },

    getNextDepartments (search) {
      const params = {
        search,
        page: this.pagination.current_page + 1
      }
      return http.get(`departments`, { params })
        .then((response) => {
          this.departments = concat(this.departments, response.data.data)
          this.pagination = response.data.meta
        })
    }
  }
}
</script>
